
<object *ngIf="documentDataType=='application/pdf'" [data]="documentData" [type]="documentDataType" class="viewer"></object>
<img *ngIf="documentDataType=='image/png'" [src]="documentData" class="image-viewer">
<img *ngIf="documentDataType=='image/jpg'" [src]="documentData" class="image-viewer">
<img *ngIf="documentDataType=='image/tif'" [src]="documentData" class="image-viewer">